import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field-updater"
// Handles text, number, and date field updates with a button
export default class extends Controller {
  static targets = ["field"]
  static values = {
    url: String,
    param: String,
    refreshDetails: Boolean,
    masterRecordingId: Number
  }

  connect() {
  }

  update(event) {
    event.preventDefault()

    const value = this.fieldTarget.value

    // Build nested parameter structure if param contains brackets
    // e.g., "master_recording[original_artist_name]" becomes { master_recording: { original_artist_name: value } }
    const data = this.buildNestedParams(this.paramValue, value)

    fetch(this.urlValue, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.ok) {
        // Success
        if (this.refreshDetailsValue && this.hasMasterRecordingIdValue) {
          this.refreshMasterRecordingDetails()
        }
        this.showSuccess()
      } else {
        this.showError()
      }
    })
    .catch(error => {
      console.error('Update error:', error)
      this.showError()
    })
  }

  refreshMasterRecordingDetails() {
    // Trigger detail row refresh if needed
    const detailRow = document.querySelector(`#master_recording_detail_${this.masterRecordingIdValue}`)
    if (detailRow && detailRow.dataset.expanded === "true") {
      // Re-fetch details by dispatching a click on the toggle
      const toggleLink = document.querySelector(`a[href="#master_recording_detail_${this.masterRecordingIdValue}"]`)
      if (toggleLink) {
        // Close and reopen to refresh
        toggleLink.click()
        setTimeout(() => toggleLink.click(), 100)
      }
    }
  }

  showSuccess() {
    // Simple success indication - could be enhanced with toast notifications
    const originalBg = this.fieldTarget.style.backgroundColor
    this.fieldTarget.style.backgroundColor = '#d4edda'
    setTimeout(() => {
      this.fieldTarget.style.backgroundColor = originalBg
    }, 1000)
  }

  showError() {
    alert('There was an error that prevented this update.')
  }

  buildNestedParams(paramName, value) {
    // Parse parameter name like "master_recording[original_artist_name]"
    // into nested structure { master_recording: { original_artist_name: value } }
    const match = paramName.match(/^([^\[]+)\[([^\]]+)\]$/)

    if (match) {
      const [, parentKey, childKey] = match
      return { [parentKey]: { [childKey]: value } }
    } else {
      // Simple parameter without nesting
      return { [paramName]: value }
    }
  }
}
